import Vue from 'vue';
import Router from 'vue-router';


const index = r => require.ensure([], () => r(require('../views/index/index')), 'index'); //首页
const search = r => require.ensure([], () => r(require('../views/index/search')), 'search'); //搜索


const aboutUs = r => require.ensure([], () => r(require('../views/aboutUs/index')), 'aboutUs'); //关于我们
const aboutUsDetail = r => require.ensure([], () => r(require('../views/aboutUs/detail')), 'aboutUsDetail'); //关于我们


const news = r => require.ensure([], () => r(require('../views/news/news')), 'news'); //新闻动态
const newsDetail = r => require.ensure([], () => r(require('../views/news/detail')), 'newsDetail'); //新闻动态详情

const meeting = r => require.ensure([], () => r(require('../views/meeting/meeting')), 'meeting'); //会议
const meetingDetail = r => require.ensure([], () => r(require('../views/meeting/detail')), 'meetingDetail'); //会议详情

const project = r => require.ensure([], () => r(require('../views/project/project')), 'project'); //项目
const projectDetail = r => require.ensure([], () => r(require('../views/project/detail')), 'projectDetail'); //项目详情

const memberService = r => require.ensure([], () => r(require('../views/memberService/memberService')), 'memberService'); //会员服务
const memberServiceDetail = r => require.ensure([], () => r(require('../views/memberService/detail')), 'memberServiceDetail'); //会员服务详情

const memberCommunication = r => require.ensure([], () => r(require('../views/memberCommunication/memberCommunication')), 'memberCommunication'); //会员交流
const memberCommunicationDetail = r => require.ensure([], () => r(require('../views/memberCommunication/detail')), 'memberCommunicationDetail'); //会员交流详情
const bbs = r => require.ensure([], () => r(require('../views/memberCommunication/bbs')), 'bbs'); //bbs主页
const bbsIndex = r => require.ensure([], () => r(require('../views/memberCommunication/bbsIndex')), 'bbsIndex'); //bbs主页
const bbsBlock = r => require.ensure([], () => r(require('../views/memberCommunication/bbsBlock')), 'bbsBlock'); //bbs板块主
const bbsDetail = r => require.ensure([], () => r(require('../views/memberCommunication/bbsDetail')), 'bbsDetail'); //bbs文章详情
const bbsUserDel = r => require.ensure([], () => r(require('../views/memberCommunication/bbsUserDel')), 'bbsUserDel'); //bbs关注的人信息





const account = r => require.ensure([], () => r(require('../views/userInfo/account')), 'account'); //账号设置



const corporate = r => require.ensure([], () => r(require('../views/corporate/corporate')), 'corporate'); //企业

const contactUs = r => require.ensure([], () => r(require('../views/contactUs/contactUs')), 'contactUs'); //联系我们

const errorPage = r => require.ensure([], () => r(require('../views/errorPage/errorPage')), 'errorPage'); //404

const userCenter = r => require.ensure([], () => r(require('../views/userCenter/userCenter')), 'userCenter'); //用户个人中心
const mainPage = r => require.ensure([], () => r(require('../views/userCenter/mainPage')), 'mainPage'); //用户个人中心主页面
const documents = r => require.ensure([], () => r(require('../views/userCenter/documents')), 'documents'); //用户个人中心我的文档
const vip = r => require.ensure([], () => r(require('../views/userCenter/vip')), 'vip'); //用户个人中心我的vip
const accountInfo = r => require.ensure([], () => r(require('../views/userCenter/accountInfo')), 'accountInfo'); //用户个人中心我的账号
const order = r => require.ensure([], () => r(require('../views/userCenter/order')), 'order'); //用户个人中心订单
const payVip = r => require.ensure([], () => r(require('../views/userCenter/payVip')), 'payVip'); //购买会员
const upload = r => require.ensure([], () => r(require('../views/userCenter/upload')), 'upload'); //购买会员
const invoice = r => require.ensure([], () => r(require('../views/userCenter/invoice')), 'invoice'); //申请发票
const invoiceSuccess = r => require.ensure([], () => r(require('../views/userCenter/invoiceSuccess')), 'invoiceSuccess'); //申请发票成功
const invoiceHistory = r => require.ensure([], () => r(require('../views/userCenter/invoiceHistory')), 'invoiceHistory'); //发票历史
const myBBS = r => require.ensure([], () => r(require('../views/userCenter/myBBS')), 'myBBS'); //bbs文章详情


Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/',
      redirect: 'index'
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        title: 'China Healthcare Business Development'
      },
    },
    {
      path: '/search',
      name: 'search',
      component: search,
      meta: {
        title: 'China Healthcare Business Development'
      },
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs,
      meta: {
        title: '关于我们'
      },
    },
    {
      path: '/aboutUsDetail',
      name: 'aboutUsDetail',
      component: aboutUsDetail,
      meta: {
        title: '关于我们详情'
      },
    },
    
    {
      path: '/news',
      name: 'news',
      component: news,
      meta: {
        title: '新闻动态'
      }
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetail,
      meta: {
        title: '新闻详情'
      }
    },
    {
      path: '/project',
      name: 'project',
      component: project,
      meta: {
        title: '项目信息'
      }
    },
    {
      path: '/projectDetail',
      name: 'projectDetail',
      component: projectDetail,
      meta: {
        title: '项目详情'
      }
    },
    {
      path: '/meeting',
      name: 'meeting',
      component: meeting,
      meta: {
        title: '会议信息'
      }
    }, {
      path: '/meetingDetail',
      name: 'meetingDetail',
      component: meetingDetail,
      meta: {
        title: '会议详情'
      }
    },
    {
      path: '/memberService',
      name: 'memberService',
      component: memberService,
      meta: {
        title: '会员服务'
      }
    }, {
      path: '/memberServiceDetail',
      name: 'memberServiceDetail',
      component: memberServiceDetail,
      meta: {
        title: '服务详情'
      }
    },

    {
      path: '/memberCommunication',
      name: 'memberCommunication',
      component: memberCommunication,
      meta: {
        title: '会员交流'
      }
    }, {
      path: '/memberCommunicationDetail',
      name: 'memberCommunicationDetail',
      component: memberCommunicationDetail,
      meta: {
        title: '会员交流'
      }
    },

    {
      path: '/corporate',
      name: 'corporate',
      component: corporate,
      meta: {
        title: '代表企业'
      }
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: contactUs,
      meta: {
        title: '联系我们'
      }
    },
    {
      path: '/account',
      name: 'account',
      component: account,
      meta: {
        title: '账号设置'
      }
    },
    {
      path: '/errorPage',
      name: 'errorPage',
      component: errorPage,
      meta: {
        title: '页面出错'
      }
    },
    {
      path: '/userCenter',
      component: userCenter,
      meta: {
        title: '个人中心'
      },
      children: [{
          path: '/',
          redirect: 'mainPage'
        },
        {
          path: '/userCenter/mainPage',
          name: 'mainPage',
          component: mainPage,
          meta: {
            title: 'China Healthcare Business Development'
          },
        },
        {
          path: '/userCenter/documents',
          name: 'documents',
          component: documents,
          meta: {
            title: 'China Healthcare Business Development'
          },
        },
        {
          path: '/userCenter/vip',
          name: 'vip',
          component: vip,
          meta: {
            title: 'China Healthcare Business Development'
          },
        },
        {
          path: '/userCenter/accountInfo',
          name: 'accountInfo',
          component: accountInfo,
          meta: {
            title: 'China Healthcare Business Development'
          },
        },
        {
          path: '/userCenter/order',
          name: 'order',
          component: order,
          meta: {
            title: 'China Healthcare Business Development'
          },
        },
        {
          path: '/userCenter/invoiceHistory',
          name: 'invoiceHistory',
          component: invoiceHistory,
          meta: {
            title: 'China Healthcare Business Development'
          },
        },
        {
          path: '/userCenter/myBBS',
          name: 'myBBS',
          component: myBBS,
          meta: {
            title: 'China Healthcare Business Development'
          },
        },
        
      ]
    },
    {
      path: '/upload',
      name: 'upload',
      component: upload,
      meta: {
        title: 'China Healthcare Business Development'
      },
    },
    {
      path: '/payVip',
      name: 'payVip',
      component: payVip,
      meta: {
        title: 'China Healthcare Business Development'
      },
    },
    {
      path: '/invoice',
      name: 'invoice',
      component: invoice,
      meta: {
        title: 'China Healthcare Business Development'
      },
    },
    {
      path: '/invoiceSuccess',
      name: 'invoiceSuccess',
      component: invoiceSuccess,
      meta: {
        title: 'China Healthcare Business Development'
      },
    },

    {
      path: '/bbs',
      name: 'bbs',
      component: bbs,
      meta: {
        title: 'China Healthcare Business Development'
      },
      children:[{
        path: '/',
        redirect: 'bbsIndex'
      },{
        path: '/bbs/bbsIndex',
        name: 'bbsIndex',
        component: bbsIndex,
        
      },{
        path: '/bbs/bbsBlock',
        name: 'bbsBlock',
        component: bbsBlock,
        
      },{
        path: '/bbs/bbsDetail',
        name: 'bbsDetail',
        component: bbsDetail,
        
      },{
        path: '/bbs/bbsUserDel',
        name: 'bbsUserDel',
        component: bbsUserDel,
      },
      
      ]
    },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js